import React from 'react';
import { Form } from 'react-bootstrap';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import Attention from '../ReusableComponents/Attention';
import FormFieldHelp from '../ReusableComponents/FormFieldHelp';
import './ProcessOptionFields.css';

export default function ProcessBooleanField({ id, label, help, value, onChange }) {
    return <div className="process-option-field">
        <Form.Label id={`${id}-label`}>{label} <Attention /> <FormFieldHelp>{help}</FormFieldHelp></Form.Label>
        <RadioGroup row aria-labelledby={`${id}-label`} name={id} value={value ? 'yes' : 'no'}
            onChange={event => onChange(event.target.value === 'yes')}>
            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
            <FormControlLabel value="no" control={<Radio />} label="Não" />
        </RadioGroup>
    </div>;
}
